import React from 'react';
import { Link, To } from 'react-router-dom';

/* Onglets accessibles (motif ARIA « tabs ») en liens : chaque onglet a son
   adresse. Les panneaux sont rendus par l'appelant avec panneauOnglet(). */
export interface Onglet { cle: string; libelle: string }

export const idOnglet = (prefixe: string, cle: string) => `${prefixe}-onglet-${cle}`;
export const idPanneau = (prefixe: string, cle: string) => `${prefixe}-panneau-${cle}`;

/** Onglets en liens (fiche de mission) : chaque onglet a son adresse, l'onglet
    courant est souligné d'orange. */
export const OngletsLiens: React.FC<{
  prefixe: string;
  onglets: Onglet[];
  actif: string;
  lien: (cle: string) => To;
  libelle: string;
}> = ({ prefixe, onglets, actif, lien, libelle }) => (
  <div role="tablist" aria-label={libelle} className="onglets">
    {onglets.map(o => (
      <Link
        key={o.cle}
        to={lien(o.cle)}
        replace
        role="tab"
        id={idOnglet(prefixe, o.cle)}
        aria-selected={actif === o.cle}
        aria-controls={idPanneau(prefixe, o.cle)}
        className="onglets__onglet"
      >
        {o.libelle}
      </Link>
    ))}
  </div>
);

/** Attributs d'un panneau : reste monté quand il est masqué (la carte garde son état). */
export const panneauOnglet = (prefixe: string, cle: string, actif: string) => ({
  role: 'tabpanel' as const,
  id: idPanneau(prefixe, cle),
  'aria-labelledby': idOnglet(prefixe, cle),
  hidden: actif !== cle,
  tabIndex: 0,
});

